var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIco404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 106,
    viewBox: "0 0 273 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.5479 67.391H83.7838V86.3962H71.5479V103.556H48.8944V86.3962H0V67.5406L41.6708 1.39671H71.5479V67.391ZM48.4521 27.0362L23.6364 66.5929V67.391H49.3366V27.0362H48.4521Z",
    fill: "#A0AEC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.141 106C109.999 105.95 93.9301 86.2465 93.9793 52.6258C94.0775 19.055 110.048 0 136.141 0C162.235 0 178.353 19.1049 178.304 52.6258C178.254 86.3463 162.284 106.05 136.141 106ZM136.141 86.2465C146.854 86.2465 153.979 75.3223 153.979 52.6258C153.93 30.2786 146.805 19.6038 136.141 19.6038C125.478 19.6038 118.402 30.2786 118.353 52.6258C118.254 75.3223 125.478 86.2465 136.141 86.2465Z",
    fill: "#A0AEC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260.764 67.391H273V86.3962H260.764V103.556H238.111V86.3962H189.216V67.5406L230.887 1.39671H260.764V67.391ZM237.668 27.0362L212.853 66.5929V67.391H238.553V27.0362H237.668Z",
    fill: "#A0AEC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco404);
export default __webpack_public_path__ + "static/media/ico-404.5f30edbb5f6fb182598c006ec3534534.svg";
export { ForwardRef as ReactComponent };